var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var RouterMatchResult = /** @class */ (function () {
    function RouterMatchResult(routeConfig, data, getContext) {
        this.routeConfig = routeConfig || {
            path: '',
            name: '',
            parents: []
        };
        this.data = data || { query: {}, params: {} };
        this.notFount = !routeConfig;
        this.redirect = (routeConfig && routeConfig.redirect) || null;
        this.getContext = getContext;
        this.guardsResult = null;
    }
    RouterMatchResult.prototype.getName = function () {
        return this.routeConfig.name || '';
    };
    RouterMatchResult.prototype.getResourceName = function () {
        var resourceName = '';
        var items = [this.routeConfig].concat(this.routeConfig.parents);
        items.some(function (i) {
            resourceName = i.resourceName || '';
            return resourceName;
        });
        return resourceName || null;
    };
    RouterMatchResult.prototype.isNotFound = function () {
        return this.notFount;
    };
    RouterMatchResult.prototype.getParams = function () {
        return __assign({}, this.data.params);
    };
    RouterMatchResult.prototype.getQuery = function () {
        return __assign({}, this.data.query);
    };
    RouterMatchResult.prototype.hasRedirect = function () {
        return !!this.redirect;
    };
    RouterMatchResult.prototype.getRedirect = function () {
        if (!this.redirect) {
            throw new Error('RouterMatchResult error: routerMatchResult is not redirect, before get redirect data check by "hasRedirect" method');
        }
        return __assign({}, this.redirect);
    };
    RouterMatchResult.prototype.isRouteActive = function (name) {
        return (this.routeConfig.name === name ||
            this.routeConfig.parents.some(function (parent) { return parent.name === name; }));
    };
    RouterMatchResult.prototype.match = function (getter) {
        var result = null;
        if (this.isDisallow()) {
            var guardResult = this.getGuardResult();
            return getter(guardResult.stubName || '') || null;
        }
        result = getter(this.getName());
        if (!result) {
            this.routeConfig.parents.reverse().some(function (parent) {
                result = getter(parent.name) || null;
                return !!result;
            });
        }
        return result;
    };
    RouterMatchResult.prototype.isAllow = function () {
        return this.getGuardResult().allow;
    };
    RouterMatchResult.prototype.isDisallow = function () {
        return !this.getGuardResult().allow;
    };
    RouterMatchResult.prototype.getGuardResult = function () {
        if (!this.guardsResult) {
            return this.executeGuards();
        }
        return __assign({}, this.guardsResult);
    };
    RouterMatchResult.prototype.executeGuards = function () {
        var _this = this;
        var guardResult = { allow: true };
        this.routeConfig.parents.concat(this.routeConfig).some(function (parent) {
            (parent.guards || []).some(function (guard) {
                guardResult = guard(_this.getContext());
                return !guardResult.allow;
            });
            return !guardResult.allow;
        });
        this.guardsResult = guardResult;
        return __assign({}, this.guardsResult);
    };
    return RouterMatchResult;
}());
export { RouterMatchResult };
//# sourceMappingURL=RouterMatchResult.js.map